(() => {
  if (customElements.get('rz-keyboard-story')) return;
  class RzKeyboardStory extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const cleanups = [];
      this.querySelectorAll('[data-demo]').forEach(card => {
        const slider = card.querySelector('input');
        const output = card.querySelector('output');
        const button = card.querySelector('[data-play]');
        const status = card.querySelector('[data-state]');
        const stem = card.querySelector('[data-stem]');
        const marker = card.querySelector('[data-marker]');
        const signal = card.querySelector('[data-signal]');
        const rapid = card.dataset.demo === 'rapid';
        let frame = 0, playing = false, previous = 0, active = false, peak = 0, trough = 0;
        const format = value => Number(value).toFixed(1).replace('.', ',') + ' mm';
        const draw = depth => {
          if (rapid) {
            // Direction-based reset/reactivation with a small illustrative movement threshold.
            if (depth > previous) { peak = depth; if (depth - trough >= .1) active = true; }
            if (depth < previous) { trough = depth; if (peak - depth >= .1) active = false; }
            if (depth <= .01) active = false;
          } else active = depth >= Number(slider.value);
          previous = depth;
          stem.setAttribute('transform', `translate(0 ${depth * 10})`);
          marker.setAttribute('transform', `translate(0 ${65 + (rapid ? depth : Number(slider.value)) / 4 * 185})`);
          signal.setAttribute('fill', active ? '#171717' : '#b9bec5');
          status.textContent = active ? 'Taste ausgelöst' : rapid && depth > .01 ? 'Taste zurückgesetzt' : 'Taste nicht ausgelöst';
          if (rapid) { slider.value = depth.toFixed(1); output.textContent = format(depth); }
        };
        const stop = () => { playing = false; cancelAnimationFrame(frame); button.textContent = 'Animation starten'; button.setAttribute('aria-pressed', 'false'); };
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          if (playing) { stop(); return; }
          playing = true;
          button.textContent = 'Animation pausieren'; button.setAttribute('aria-pressed', 'true');
          const start = performance.now();
          const tick = time => {
            if (!playing) return;
            // Rapid Trigger visibly resets above the bottom, then reactivates on a partial press.
            const points = rapid ? [0,3.5,1.8,3,0] : [0,4,0];
            const cycle = ((time - start) % 4800) / 4800 * (points.length - 1);
            const i = Math.floor(cycle), fraction = cycle - i;
            draw(points[i] + (points[i + 1] - points[i]) * (.5 - Math.cos(fraction * Math.PI) / 2));
            frame = requestAnimationFrame(tick);
          };
          frame = requestAnimationFrame(tick);
        }, { signal: controller.signal });
        slider.addEventListener('input', () => {
          output.textContent = format(slider.value);
          if (rapid) { stop(); draw(Number(slider.value)); }
          else draw(previous);
        }, { signal: controller.signal });
        output.textContent = format(slider.value); draw(0);
        let introduced = false;
        const observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) { stop(); return; }
          if (!introduced) {
            introduced = true;
            if (!matchMedia('(prefers-reduced-motion: reduce)').matches) button.click();
          }
        }, { threshold: .25 });
        observer.observe(card);
        cleanups.push(() => { stop(); observer.disconnect(); });
      });
      const audio = this.querySelector('audio');
      this.cleanup = () => { controller.abort(); cleanups.forEach(fn => fn()); audio?.pause(); };
    }
    disconnectedCallback() { this.cleanup?.(); }
  }
  customElements.define('rz-keyboard-story', RzKeyboardStory);
})();
